export const getZoneIdFromOption = option => {
	const value = option?.zoneId ?? option?.id;

	if (value === undefined || value === null || value === '') return undefined;

	const zoneId = Number(value);

	return Number.isSafeInteger(zoneId) && zoneId > 0 ? zoneId : undefined;
};

export const requestZoneAssignment = ({
	option,
	orderId,
	setZoneAssignment,
}) => {
	const zoneId = getZoneIdFromOption(option);

	if (!zoneId) return undefined;

	return setZoneAssignment(zoneId, orderId);
};
